/**
 * One copy path for the whole admin (AB#655).
 *
 * Callers used to fire `navigator.clipboard.writeText(...)` and toast success on
 * the next line — the promise can reject (insecure context, denied permission,
 * no focus) and the user is told it worked when it didn't. Everything routes
 * through here instead: await, fall back to execCommand, report the truth.
 */
import { toast } from 'sonner';

export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // fall through to the legacy path
  }
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    if (ok) return true;
  } catch {
    // reported below
  }
  toast.error('Copy failed — select and copy manually');
  return false;
}
